
export const UpdateReducer = (state= null, action) => {
    switch(action.type){
        case 'richtext':
            return action.payload
        case 'announce':
            return action.payload
        case 'wood':
            return action.payload
        default:
            return state
    }
}